export default {"src":"/_next/static/image/components/ui/Icon/icons/location.5981021162289ab85968a59d89aaf224.svg","height":26,"width":22};